"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_progress_1 = require("rc-progress");
var utils_1 = require("./utils");
function getPercentage(_a) {
    var percent = _a.percent, success = _a.success, successPercent = _a.successPercent;
    var ptg = (0, utils_1.validProgress)(percent);
    var realSuccessPercent = (0, utils_1.getSuccessPercent)({ success: success, successPercent: successPercent });
    if (!realSuccessPercent) {
        return ptg;
    }
    return [
        (0, utils_1.validProgress)(realSuccessPercent),
        (0, utils_1.validProgress)(ptg - (0, utils_1.validProgress)(realSuccessPercent)),
    ];
}
function getStrokeColor(_a) {
    var success = _a.success, strokeColor = _a.strokeColor, successPercent = _a.successPercent;
    var color = strokeColor || null;
    var realSuccessPercent = (0, utils_1.getSuccessPercent)({ success: success, successPercent: successPercent });
    if (!realSuccessPercent) {
        return color;
    }
    return ['#52C41A', color];
}
var Circle = function (props) {
    var _a;
    var prefixCls = props.prefixCls, strokeWidth = props.strokeWidth, trailColor = props.trailColor, strokeLinecap = props.strokeLinecap, gapPosition = props.gapPosition, gapDegree = props.gapDegree, type = props.type, children = props.children, size = props.size;
    var circleSize = size === 'small' ? 96 : 160;
    var circleStyle = {
        width: circleSize,
        height: circleSize,
        fontSize: size === 'small' ? 16 : 24,
    };
    var defaultWidth = size === 'small' ? 6 : 5;
    var circleWidth = strokeWidth || defaultWidth;
    var gapPos = gapPosition || (type === 'dashboard' && 'bottom') || 'top';
    var getGapDegree = function () {
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) {
            return gapDegree;
        }
        if (type === 'dashboard') {
            return 75;
        }
        return undefined;
    };
    // using className to style stroke color
    var strokeColor = getStrokeColor(props);
    var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
    var wrapperClassName = (0, classnames_1.default)("".concat(prefixCls, "-inner"), (_a = {},
        _a["".concat(prefixCls, "-circle-gradient")] = isGradient,
        _a));
    return (React.createElement("div", { className: wrapperClassName, style: circleStyle },
        React.createElement(rc_progress_1.Circle, { percent: getPercentage(props), strokeWidth: circleWidth, trailWidth: circleWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap, trailColor: trailColor, prefixCls: prefixCls, gapDegree: getGapDegree(), gapPosition: gapPos }),
        children));
};
exports.default = Circle;
//# sourceMappingURL=Circle.js.map